export default class Standartteminat {
  id: any;
  tanim: any;
  kaskoTeminatTuruId: any;
  varsayilanMi: any;
}
